import { useMutation, useQueryClient } from '@tanstack/react-query';
import { bidKeys } from '@tempmee/awards';
import type { ISubmitBidApplicationParams } from '../clients/SubmitBidApplication';
import { submitBidApplicationService } from '../services/SubmitBidApplication';

/** @param officeId - the location a Manage row opened the page for; omit for the selected office */
export const useSubmitBidApplication = (officeId?: string) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (params: ISubmitBidApplicationParams) =>
      submitBidApplicationService(params, officeId),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: bidKeys.all });
    },
    meta: { skipGlobalErrorToaster: true },
  });
};
